<script>
export default {
  name: "ModalBlock",

  props: {
    blockId: {
      type: String,
    }
  },

  computed: {
    modalId() {
      return _.uniqueId('modal-block-');
    },

    storageId() {
      return `modal-block-${this.blockId}`;
    }
  },

  mounted() {
    this.show();
  },

  methods: {
    show() {
      if (window.sessionStorage.getItem(this.storageId) === 'true') {
        return
      }

      document.documentElement.style.overflowY = "hidden"
      document.documentElement.style.height = "100vh"

      this.$modal.show(this.modalId);
    },

    close() {
      this.setSessionStorage();
      this.$modal.hide(this.modalId);
    },

    handleClose() {
      document.documentElement.style.overflowY = "auto"
      document.documentElement.style.height = "auto"
    },

    setSessionStorage() {
      window.sessionStorage.setItem(this.storageId, 'true');
    }
  }
}
</script>

<template>
  <div class="vue-modal-block">
    <modal :id="modalId" :name="modalId" width="90%" :maxWidth="1170" :adaptive="true" height="auto" :scrollable="true" @closed="setSessionStorage" @before-close="handleClose">
      <div class="modal-inner-wrapper">
        <a class="close-button" href="" @click.prevent="close"></a>

        <div class="inner">
          <div class="content-left">
            <slot name="left"></slot>
          </div>
          <div class="content-right">
            <slot name="right"></slot>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
